<template>
  <el-dialog :title="title"
             :visible.sync="dialogVisible"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :modal-append-to-body="false"
             :width="width"
             class="tips-dialog"
             @close="closeModal(false)">
    <!-- <span>这是一段信息</span> -->
    <slot name="content"></slot>
    <span slot="footer"
          class="dialog-footer"
          v-if="isFooter">
      <el-button type="primary"
                 :loading="loading"
                 @click="closeModal(true)">{{confirm}}</el-button>
      <el-button @click="closeModal(false)">{{cancel}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "modalTips",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "30%"
    },
    title: {
      type: String,
      default: ""
    },
    confirm: {
      type: String,
      default: "确 定"
    },
    cancel: {
      type: String,
      default: "取 消"
    },
    isFooter: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return { loading: false };
  },
  methods: {
    closeModal (flag) {
      this.loading = flag;
      this.$emit("close-modal", flag);
    }
  },
  mounted () { }
};
</script>
<style lang="less">
.tips-dialog {
  > div {
    border-radius: 8px;
    .el-dialog__header {
      padding: 15px;
      text-align: left;
      // border-bottom: 1px solid #e6e6e6;
      .el-dialog__title {
        font-size: 16px;
        letter-spacing: 1px;
      }
    }
    .el-dialog__footer {
      text-align: center;
      padding: 15px;
      // border-top: 1px solid #e6e6e6;
      .dialog-footer {
        .el-button {
          height: 30px;
          line-height: 28px;
          padding: 0 20px;
        }
        .el-button--primary {
          color: #fff;
          background: #3c81f5;
          //radial-gradient(
          //   circle farthest-corner at 0% 100%,
          //   #006cff,
          //   #00a3ff
          // );
          border-radius: 30px;
          margin-right: 20px;
        }
        .el-button--default {
          border-radius: 30px;
          background: #f7f4fa;
          border: 1px solid #f7f4fa;
          color: #a7b1ca;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/modalTips/modalTips.vue